import { render } from "./Bm.vue?vue&type=template&id=2d8cc81b&scoped=true"
import script from "./Bm.vue?vue&type=script&lang=js"
export * from "./Bm.vue?vue&type=script&lang=js"

import "./Bm.vue?vue&type=style&index=0&id=2d8cc81b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8cc81b"]])

export default __exports__